<template>
    <div>
        <template v-if="hasPermission">
            <vx-card noShadow noRound>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                        <label class="vs-input--label block mr-3">Name</label>
                        <vs-input
                            v-model="stock.name"
                            class="w-full"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.name">
                            {{ api_errors.name.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                        <label class="vs-input--label block mr-3">Rate</label>
                        <vs-input
                            v-model="stock.rate"
                            class="w-full"
                            type="Number"
                            step="0.001"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.rate">
                            {{ api_errors.rate.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                        <label class="vs-input--label block mr-3">Opening Stock</label>
                        <vs-input
                            v-model="stock.opening_stock"
                            class="w-full"
                            type="Number"
                            step="0.001"
                            :readonly="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.opening_stock">
                            {{ api_errors.opening_stock.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mt-3">
                        <SelectForeign
                            :model.sync="stock.category"
                            label="Select Category"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.stock_categories}?active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                            @change="!stock.id ? stock.sub_category = null : null"
                            :disabled="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.category">
                            {{ api_errors.category.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mt-3">
                        <SelectForeign
                            :model.sync="stock.sub_category"
                            label="Select Sub Category"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="stock.category ? true : false"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.stock_subcategories}?active=true&category=${stock.category ? stock.category.id : null}`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                            :disabled="!stock.category && !editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.sub_category">
                            {{ api_errors.sub_category.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mt-3">
                        <SelectForeign
                            :model.sync="stock.unit_of_measurement"
                            label="Select UOM"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.stock_uoms}?active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                            :disabled="!editPermission"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.unit_of_measurement">
                            {{ api_errors.unit_of_measurement.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                
                <vs-row class="mt-base" v-if="editPermission">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import { Request } from "../../utils/requests";

export default {
    data() {
        return {
            stock_id: this.$route.params.stock_id,

            stock: {
                id: null,
                name: null,
                category: null,
                sub_category: null,
                unit_of_measurement: null,
                rate: null,
                opening_stock: 0,
                active: true
            },

            submit_disabled: false,
            api_errors: {}
        }
    },
    watch: {
        "$route.params.stock_id"(newV, oldV) {
            if (newV == oldV)
                return;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        viewStock() {
            return this.hasAccess('read', 'stock', 'all')
        },
        createStock() { 
            return this.hasAccess('create', 'stock', 'all') 
        },
        editStock() { 
            return this.hasAccess('edit', 'stock', 'all') 
        },
        hasPermission() {
            return (!this.stock.id && this.createStock) || (this.stock.id && this.editStock) || (this.stock.id && this.viewStock)
        },
        editPermission() {
            return (!this.stock.id && this.createStock) || (this.stock.id && this.editStock)
        }
    },
    methods: {
        init() {
            this.stock_id = this.$route.params.stock_id

            if (this.stock_id) this.load_data()
            else this.stock = {
                id: null,
                name: null,
                category: null,
                sub_category: null,
                unit_of_measurement: null,
                rate: null,
                opening_stock: 0,
                active: true
            }
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.stock_get + this.stock_id + "/"
            
            this.$vs.loading()
            
            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.stock = res
                },
                err => {
                    this.$vs.loading.close()
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let request_method = 'POST', url = this.$store.state.apiendpoints.stock_get
            if (this.stock_id) {
                request_method = 'PUT'
                url += this.stock_id + '/'
            }

            let payload = this.stock

            this.submit_disabled = true

            Request(this, request_method, url, null, payload).then(
                res => {
                    this.submit_disabled = false
                    this.stock = res
                    
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Saved Successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.$router.push({name: 'stock-list'})
                },
                err => {
                    this.submit_disabled = false
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })

                    }
                }
            )
        }
    }
}
</script>